var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-area scroll-fire-fox" },
    [
      _vm._t("fields"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "buttons-container" },
        [
          _vm.generateButton
            ? _c("management-button", {
                staticStyle: { margin: "10px 0" },
                attrs: {
                  label: _vm.$t("GenerateFile"),
                  type: "execute",
                  disabled:
                    _vm.buttonsDisabled ||
                    !_vm.userHasManagementPermission("export_store")
                },
                on: { buttonClick: _vm.generateReport }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("customButton")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13d72c61", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13d72c61","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Reports/Form/FormArea.vue
// module id = null
// module chunks = 